<nb-card class="mb-0 full-height-modal no-edge-card">
	<nb-card-header class="flex border-bottom-0">
		<div class="col-10 modal-title">
			<h2>{{ "SETTINGS.GENERALTITLE" | translate }}</h2>
		</div>
	</nb-card-header>
	<div class="closeModal">
		<nb-icon class="m-1" icon="checkmark-circle-2" nbTooltip="{{ 'GLOBALS.SAVEANDCLOSE' | translate }}"
			nbTooltipPlacement="left" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal('')">
		</nb-icon>
	</div>
	<nb-card-body *ngIf="userData">
		<div *ngIf="screenView === 1">
			<form
				[formGroup]="formularioDatos"
				(ngSubmit)="grabarDatos()"
				#thisForm="ngForm">
				<nb-card class="project-info no-edge-card mb-0 compact-settings">
					<app-loading [isVisible]="loading"></app-loading>
					<nb-card-body class="p-0">
						<app-alert context="UserData"></app-alert>

						<p class="text-alert mb-2" *ngIf="profilesLoaded && !userData.profileEditor">
							{{ "PARENTS.ACCESSLIMITED" | translate }}
							<a class="pointer" (click)="ajustes()"><b>{{ "PARENTS.PUSHTOASSIGN" | translate }}</b></a>
						</p>

						<div class="section-title">
							<h6 class="mb-0">{{ "LOGIN.DATAPROFILE" | translate }}</h6>
						</div>

						<div class="row align-items-center profile-row">
							<div class="col-md-4">
								<app-image-profile [image]="userData.pictureUser" *ngIf="userData"></app-image-profile>
							</div>
							<div class="col-md-8 container-profile" *ngIf="!isMobile">
								<div class="profile-toggle">
									<div class="item-toggle">
										<nb-toggle labelPosition="end" [checked]="true" disabled></nb-toggle>
										<span nbTooltip="{{ 'LOGIN.TITLEEDITOR' | translate }}" nbTooltipPlacement="bottom"
											nbTooltipStatus="primary" nbButton status="primary">{{ "LOGIN.EDITOR" | translate }}</span>
									</div>

									<ng-container *ngIf="isAdult">
										<div class="item-toggle">
											<nb-toggle labelPosition="end" formControlName="profileParent" (change)="guardarPerfil()"></nb-toggle>
											<span nbTooltip="{{ 'LOGIN.PARENT' | translate }}" nbTooltipPlacement="bottom" nbTooltipStatus="primary"
												nbButton status="primary">{{ "LOGIN.PARENT" | translate }}</span>
										</div>
									</ng-container>

									<div class="item-toggle">
										<nb-toggle labelPosition="end" formControlName="profileStudent" (change)="guardarPerfil()"></nb-toggle>
										<span nbTooltip="{{ 'LOGIN.TITLESTUDENT' | translate }}" nbTooltipPlacement="bottom"
											nbTooltipStatus="primary" nbButton status="primary">{{ "LOGIN.STUDENT" | translate }}</span>
									</div>

									<ng-container *ngIf="isAdult">
										<div class="item-toggle">
											<nb-toggle labelPosition="end" formControlName="profileTeacher" (change)="guardarPerfil()"></nb-toggle>
											<span nbTooltip="{{ 'LOGIN.TITLETEACHER' | translate }}" nbTooltipPlacement="bottom"
												nbTooltipStatus="primary" nbButton status="primary">{{ "LOGIN.TEACHER" | translate }}</span>
										</div>

										<div class="item-toggle">
											<nb-toggle labelPosition="end" formControlName="profileCenter" (change)="guardarPerfil()"></nb-toggle>
											<span nbTooltip="{{ 'LOGIN.TITLECENTER' | translate }}" nbTooltipPlacement="bottom"
												nbTooltipStatus="primary" nbButton status="primary">{{ "LOGIN.CENTER" | translate }}</span>
										</div>
									</ng-container>
								</div>
							</div>
						</div>

						<hr class="section-divider">

						<div class="section-title">
							<h6 class="mb-0">{{ "USERDATA.DATOSGENERALES" | translate }}</h6>
						</div>

						<div class="general-data-section">
								<div class="col-12">
									<div class="row">
										<div class="col-12 col-md-6 form-group">
											<label for="username" class="label">{{"USERDATA.NOMBRE" | translate}}</label>
											<input
												type="text"
												nbInput
												fullWidth
												class="form-control"
												status="basic"
												fieldSize="small"
												placeholder="{{ 'USERDATA.NOMBRE' | translate }}"
												name="username"
												formControlName="firstName"
												required />
											<div
												*ngFor="let validation of validationMessages.firstName">
												<mat-error
													*ngIf="(userData.profileEditor)&&
														(formularioDatos
															.get('firstName')
															?.hasError(validation.type) &&
														(formularioDatos.get('firstName')?.dirty ||
															formularioDatos.get('firstName')?.touched ||
															thisForm.submitted))">
													<div class="error-message" >
														{{ validation.message }}
													</div>
												</mat-error>
											</div>
										</div>

										<div class="col-12 col-md-6 form-group">
											<label for="surname" class="label">{{"USERDATA.APELLIDOS" | translate}}</label>
											<input
												type="text"
												nbInput
												fullWidth
												class="form-control"
												status="basic"
												fieldSize="small"
												placeholder="{{ 'USERDATA.APELLIDOS' | translate }}"
												name="surname"
												formControlName="surname"
												required />
											<div
												*ngFor="let validation of validationMessages.surname">
												<mat-error
													*ngIf="userData.profileEditor &&
														(formularioDatos
															.get('surname')
															?.hasError(validation.type) &&
														(formularioDatos.get('surname')?.dirty ||
															formularioDatos.get('surname')?.touched ||
															thisForm.submitted))">
													<div class="error-message">
														{{ validation.message }}
													</div>
												</mat-error>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-12 col-md-6 form-group" *ngIf="!isDemo">
											<label for="mail" class="label">{{"USERDATA.EMAIL" | translate}}</label>
											<input
												type="email"
												nbInput
												fullWidth
												class="form-control"
												[status]="emailExists ? 'danger' : 'basic'"
												fieldSize="small"
												placeholder="{{ 'USERDATA.EMAIL' | translate }}"
												name="mail"
												formControlName="mail"
												required
												(input)="onMailChange()"
											/>
											<div *ngIf="emailExists" class="error-message mt-1">
												{{ "VALIDACIONES.EMAILEXISTE" | translate }}
											</div>
											<div *ngFor="let validation of validationMessages.mail">
												<mat-error
													*ngIf="userData.profileEditor &&
														(formularioDatos
															.get('mail')
															?.hasError(validation.type) &&
														(formularioDatos.get('mail')?.dirty ||
															formularioDatos.get('mail')?.touched ||
															thisForm.submitted))">
													<div class="error-message">
														{{ validation.message }}
													</div>
												</mat-error>
											</div>
										</div>

										<div class="col-12 col-md-6 form-group">
											<label for="birthdate" class="label">{{"USERDATA.DATE" | translate}}</label>
											<input
												type="date"
												nbInput
												fullWidth
												class="form-control"
												status="basic"
												fieldSize="small"
												name="birthdate"
												formControlName="birthdate"/>
											<div
												*ngFor="let validation of validationMessages.birthdate">
												<mat-error
													*ngIf="userData.profileEditor &&
														(formularioDatos
															.get('birthdate')
															?.hasError(validation.type) &&
														(formularioDatos.get('birthdate')?.dirty ||
															formularioDatos.get('birthdate')?.touched ||
															thisForm.submitted))">
													<div class="error-message">
														{{ validation.message }}
													</div>
												</mat-error>
											</div>
										</div>
									</div>

									<div class="row" *ngIf="!isDemo">
										<div class="col-12 col-md-6 form-group">
											<label for="prefix" class="label">{{"LOGIN.PREFIX" | translate}}</label>
											<nb-select
												fullWidth
												name="prefix"
												hero size="small"
												class="SelectForm"
												placeholder="{{ 'LOGIN.PREFIX' | translate }}"
												formControlName="prefix"
												(selectionChange)="onMobileOrPrefixChange()"
												(click)="onClickSelect($event)">
												<nb-option class="SelectFormOpt"
													*ngFor="let prefix of $phonePrefixes | async"value="{{ prefix.dial_code }}">{{ prefix.name_en }}
													<span>
														<strong>{{ prefix.dial_code }}</strong>
													</span>
												</nb-option>
											</nb-select>
											<div
												*ngFor="let validation of validationMessages.prefix"
												class="mt-2">
												<div
													class="error-message"
													*ngIf="userData.profileEditor &&
														(prefixControl?.hasError(validation.type) &&
														(prefixControl?.dirty ||
															prefixControl?.touched ||
															thisForm.submitted))">
													{{ validation.message }}
												</div>
											</div>
										</div>

										<div class="col-12 col-md-6 form-group">
											<label for="mobile" class="label">{{"USERDATA.TELEFONOMOVIL" | translate}}</label>
											<input
												type="text"
												nbInput
												fullWidth
												class="form-control"
												status="basic"
												fieldSize="small"
												placeholder="{{ 'USERDATA.TELEFONOMOVIL' | translate }}"
												name="mobile"
												formControlName="mobile"
												required
												(input)="onMobileOrPrefixChange()"
											/>
											<div *ngFor="let validation of validationMessages.mobile">
												<mat-error
													*ngIf="userData.profileEditor &&
														(formularioDatos
															.get('mobile')
															?.hasError(validation.type) &&
														(formularioDatos.get('mobile')?.dirty ||
															formularioDatos.get('mobile')?.touched ||
															thisForm.submitted))">
													<div class="error-message">
														{{ validation.message }}
													</div>
												</mat-error>
											</div>

											<div *ngIf="isMobileChanged() && !smsSent" class="mt-2">
												<button nbButton size="small" type="button" class="btn-themecolor"
													[disabled]="smsVerifying"
													(click)="requestSmsVerification()">
													{{ "CAMBIARMOVIL.GETCODE" | translate }}
												</button>
											</div>

											<div *ngIf="smsSent" class="mt-2">
												<label for="smsCode" class="label">{{ "CAMBIARMOVIL.ENTERVERIFICATIONCODE" | translate }}</label>
												<input
													#smsCodeInput
													type="text"
													nbInput
													fullWidth
													class="form-control"
													[status]="pinError ? 'danger' : 'basic'"
													fieldSize="small"
													name="smsCode"
													maxlength="6"
													(input)="onPinInput($event)"
												/>
												<div *ngIf="pinError" class="error-message mt-1">{{ "CAMBIARMOVIL.ERRORCODE" | translate }}</div>
												<div class="d-flex align-items-center gap-3 mt-2">
													<div class="error-message">{{ "CAMBIARMOVIL.ALERTLOGOUT" | translate }}</div>
												</div>
												<div *ngIf="pinError" class="mt-2">
													<button nbButton size="small" type="button" class="btn-themecolor"
														[disabled]="smsVerifying"
														(click)="requestSmsVerification()">
														{{ "CAMBIARMOVIL.RESENDCODE" | translate }}
													</button>
												</div>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-12 col-md-6 form-group">
											<label for="idGenre" class="label">{{"USERDATA.GENRE" | translate}}</label>
											<nb-select
												fullWidth
												name="idGenre"
												hero size="small"
												class="SelectForm"
												placeholder="{{ 'USERDATA.GENRE' | translate }}"
												formControlName="idGenre"
												(click)="onClickSelect($event)">
												<nb-option value="null" disabled>{{"USERDATA.GENRE" | translate}}</nb-option>
												<nb-option class="SelectFormOpt"
													*ngFor="let gender of genres"
													[value]="gender.idGenre">{{ gender.genre | translate }}
												</nb-option>
											</nb-select>

											<mat-error
												*ngFor="let validation of validationMessages.gender">
												<mat-error
													class="error-message break-line"
													*ngIf="userData.profileEditor &&
														(formularioDatos
															.get('idGenre')
															?.hasError(validation.type) &&
														(formularioDatos.get('idGenre')?.dirty ||
															formularioDatos.get('idGenre')?.touched ||
															thisForm.submitted))">{{ validation.message }}
												</mat-error>
											</mat-error>
										</div>

										<div class="col-12 col-md-6 form-group">
											<label for="idLanguageIso" class="label">{{"IDIOMA.SELECCIONEELIDIOMA" | translate }}</label>
											<nb-select
												fullWidth
												name="idLanguageIso"
												hero size="small"
												class="SelectForm"
												placeholder="{{'IDIOMA.SELECCIONEELIDIOMA' | translate}}"
												formControlName="idLanguageIso"
												(selectionChange)="selectLang($event)"
												(click)="onClickSelect($event)">
												<nb-option value="null" disabled>{{"IDIOMA.SELECCIONEELIDIOMA" | translate}}</nb-option>
												<nb-option class="SelectFormOpt"
													*ngFor="let lang of langList"
													value="{{ lang.idLanguageIso }}">
													{{ lang.idLanguageIso | translate }}
												</nb-option>
											</nb-select>

											<mat-error
												*ngFor="let validation of validationMessages.gender">
												<mat-error
													class="error-message break-line"
													*ngIf="userData.profileEditor &&
														(formularioDatos
															.get('idLanguageIso')
															?.hasError(validation.type) &&
														(formularioDatos.get('idLanguageIso')?.dirty ||
															formularioDatos.get('idLanguageIso')?.touched ||
															thisForm.submitted))">{{ validation.message }}
												</mat-error>
											</mat-error>
										</div>
									</div>

									<div class="action-links" *ngIf="userData.profileEditor">
										<a class="pointer" (click)="changePass()">
											<span>{{ "CAMBIARPASS.CAMBIARPASS" | translate }}</span>
										</a>
										<a class="pointer" (click)="changeMobile()">
											<span>{{ "CAMBIARMOVIL.CAMBIARMOVIL" | translate }}</span>
										</a>
										<a class="pointer" (click)="changeMail()">
											<span>{{ "CAMBIARMAIL.CAMBIARMAIL" | translate }}</span>
										</a>
										<a class="pointer text-danger" (click)="dropOut()">
											<span>{{ "DARSEBAJA.DARSEBAJA" | translate }}</span>
										</a>
									</div>
								</div>
						</div>
					</nb-card-body>
				</nb-card>
			</form>
		</div>
		<div *ngIf="screenView === 2">
			<nb-card class="no-edge-card mb-0">
				<nb-card-header>
					<h6>{{ "CAMBIARPASS.CAMBIARPASS" | translate }}</h6>
				</nb-card-header>
				<nb-card-body class="p-0">
					<app-modal-change-pass
						(action)="backToGeneral($event)"
					></app-modal-change-pass>
				</nb-card-body>
			</nb-card>
		</div>
		<div *ngIf="screenView === 3">
			<nb-card class="no-edge-card mb-0">
				<nb-card-header>
					<h6>{{ "CAMBIARMOVIL.CAMBIARMOVIL" | translate }}</h6>
				</nb-card-header>
				<nb-card-body>
					<app-modal-change-mobile
						(action)="backToGeneral($event)"
					></app-modal-change-mobile>
				</nb-card-body>
			</nb-card>
		</div>
		<div *ngIf="screenView === 4">
			<nb-card class="no-edge-card mb-0">
				<nb-card-header>
					<h6>{{ "CAMBIARMAIL.CAMBIARMAIL" | translate }}</h6>
				</nb-card-header>
				<nb-card-body>
					<app-modal-change-mail
						(action)="backToGeneral($event)" [userData]="userData"
					></app-modal-change-mail>
				</nb-card-body>
			</nb-card>
		</div>
		<div *ngIf="screenView === 5">
			<nb-card class="no-edge-card mb-0">
				<nb-card-header>
					<h6>{{ "DARSEBAJA.DARSEBAJA" | translate }}</h6>
				</nb-card-header>
				<nb-card-body>
					<app-modal-drop-out
						(action)="backToGeneral($event)"
					></app-modal-drop-out>
				</nb-card-body>
			</nb-card>
		</div>
	</nb-card-body>

</nb-card>


